import { render, staticRenderFns } from "./dialog-checksendtoonechatmulti.vue?vue&type=template&id=33c36e27&"
import script from "./dialog-checksendtoonechatmulti.vue?vue&type=script&lang=js&"
export * from "./dialog-checksendtoonechatmulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports